<template>
    <v-main v-on:drop.prevent class="mx-xl-12 px-xl-12 mx-md-5 px-md-5 mx-sm-2 px-sm-2 my-0 py-0"
               style="height: 100%;">
        <v-layout row class="my-10">
            <v-flex md12 sm12>
                <div class="ml-6">
                    <div class="text-center text__colour-teal text__size-32 text__style-bold layout__margin__bottom-20">Start building your direct mail campaign</div>

                    <div class="text-center text__colour-teal text__size-32 text__style-bold layout__margin__bottom-20">Choose your data below</div>

                    <v-layout row class="layout__width-1100px layout__margin-0-auto">
                        <v-flex md4 px-2>
                            <v-card width="340" height="500" color="white" raised class="text-center" @click="fulfilmentChosen('1', '2')">
                                <v-img class="white--text align-end" src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_marketing/MyRav_On_The_Market.jpg" eager>
                                </v-img>

                                <div class="text__colour-teal pt-4 text__size-26 text__style-bold">On Market Data</div>
                                <v-card-subtitle class="text__colour-teal text__size-18 pb-0 layout__margin__bottom-20">
                                    Dramatically increase your listings by<br>canvassing properties currently on the<br>market with a competitor.
                                </v-card-subtitle>

                                <v-card-actions>
                                    <v-row class="fill-height my-4" align="center" justify="center">
                                        <el-button class="button__base layout__width-200px button__background-red layout__cursor-pointer layout__float-right">
                                                Continue
                                        </el-button>
                                    </v-row>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex md4 px-2>
                            <v-card width="340" height="500" color="white" raised class="text-center" @click="fulfilmentChosen('2', '2')">
                                <v-img class="white--text align-end" src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_marketing/MyRav_Direct_Mail.jpg" eager>
                                </v-img>
                                <div class="text__colour-teal pt-4 text__size-26 text__style-bold">Household data</div>
                                <v-card-subtitle class="text__colour-teal text__size-18 pb-0 layout__margin__bottom-20">
                                    Access pay as you go address data to<br>achieve highly targeted campaigns.<br>&nbsp;
                                </v-card-subtitle>
                                <v-card-actions>
                                    <v-row class="fill-height my-4" align="center" justify="center">
                                        <el-button class="button__base layout__width-200px button__background-red layout__cursor-pointer layout__float-right">
                                                Continue
                                        </el-button>
                                    </v-row>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <v-flex md4 px-2>
                            <!--<v-card width="340" height="500" color="white" raised class="text-center" @click="fulfilmentChosen('3', '2')">-->
                            <v-card width="340" height="500" color="white" raised class="text-center">
                                <v-img class="white--text align-end" src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_marketing/MyRav_Upload_Your_Own.jpg" eager>
                                </v-img>
                                <div class="text__colour-grey pt-4 text__size-26 text__style-bold">Upload your own</div>
                                <v-card-subtitle class="text__colour-grey text__size-18 pb-0 layout__margin__bottom-20">
                                    Upload your own data list and harness<br>the power of direct mail.<br>&nbsp;
                                </v-card-subtitle>
                                <v-card-actions>
                                    <v-row class="fill-height my-4" align="center" justify="center">
                                        <el-button class="button__base layout__width-200px button__background-red layout__cursor-pointer layout__float-right" disabled>
                                                Coming soon
                                        </el-button>
                                    </v-row>
                                </v-card-actions>
                            </v-card>
                        </v-flex>

                        <!--<div class="layout__padding__top-120px">
                            <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-left"
                                    v-on:click="goBack()">Back
                            </el-button>
                        </div>-->

                        <v-row>
                            <v-col cols="12">
                                <div class="layout__padding__top-120px">
                                    <el-button class="button__base layout__width-200px button-teal layout__cursor-pointer layout__float-left"
                                            v-on:click="goBack();">Back
                                    </el-button>

                                    <!--TEMPORARY!!!-->
                                    <!--<el-button class="button__base layout__width-200px button__background-red layout__cursor-pointer layout__float-right"
                                            v-on:click="navigate('pageflex')">Pageflex
                                    </el-button>-->
                                </div>
                            </v-col>
                        </v-row>
                    </v-layout>

                    <v-overlay :value="loading">
                        <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                </div>
            </v-flex>
        </v-layout>
    </v-main>
</template>

<script>

    import Router from '../../router.js'
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';

    export default {
        name: 'InstantMarketingFulfilement',
        components: {
        },
        mixins: [axios],
        data() {
            return {
                loading: false,
                order: {},
                connection_params: {},
                customer: {},
                templatingValues: {},
                user: {},
            }
        },
        watch: {
            order: {
                handler(order){
                    console.log('updating order object ', this.order)
                    window.sessionStorage.setItem('_order_data', JSON.stringify(order));
                },
                deep: true
            },
        },
        mounted() {
            this.connection_params = JSON.parse(window.sessionStorage.getItem('_connection_params'));
            this.customer = JSON.parse(window.sessionStorage.getItem('customer'));
            this.templatingValues = JSON.parse(window.sessionStorage.getItem('templatingValues'));
            this.user = JSON.parse(window.sessionStorage.getItem('user'));

            if (this.connection_params.fulfilment !== '' && this.connection_params.data_ref !== '') {
                this.navigate('data-preview');
            } else if (this.connection_params.fulfilment !== '') {
                this.navigate('select-data');
            }

            parent.postMessage('ScrollIntoView', '*');
        },
        methods: {
            navigate(path) {
                setTimeout(function () {
                    console.log('new page')
                    Router.push({
                        path: '/' + path,

                    });
                }, 2);
            },
            fulfilmentChosen(dataType, fulfilmentType) {
                this.loading = true;

                var sourcePartner = 'MYRAV',
                    partnerRef = '',
                    dataProvider = ''

                if (window.sessionStorage.getItem('_sourcePartner') !== null) {
                    sourcePartner = window.sessionStorage.getItem('_sourcePartner');
                }

                if (window.sessionStorage.getItem('_partnerRef') !== null) {
                    partnerRef = window.sessionStorage.getItem('_partnerRef');
                }

                const start_order = {
                    'userId': this.user.id,
                    'customerReference': '',
                    'sourcePartner': sourcePartner,
                    'partnerRef': partnerRef,
                    'branchId': this.customer.ref,
                    'fulfilmentType': fulfilmentType,
                }

                console.log('start_order=' + JSON.stringify(start_order));

                const postInitialOrderInfo = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder`;

                Axios.post(postInitialOrderInfo, start_order, this.returnHeaderUsingToken())
                    .then (response => {
                        console.log(response)

                        let orderId = JSON.stringify(response.data.id);
                        window.sessionStorage.setItem('_order_id', orderId);

                        if (dataType == '1') {
                            dataProvider = 'Leadhub';
                        }

                        if (dataType == '2') {
                            dataProvider = 'Databook';
                        }

                        const patch_order = `${process.env.VUE_APP_TKGATEWAY}/api/DataOrder/` + orderId;

                        const update_body = [
                            {
                                "value": dataProvider,
                                "path": "/dataProvider",
                                "op": "replace",
                                "from": "string"
                            }
                        ]

                        Axios.patch(patch_order, update_body, this.returnHeaderUsingToken())
                            .then(response => {
                                console.log(response.data);

                                window.sessionStorage.removeItem('_databook_auth_token');
                                window.sessionStorage.removeItem('_leadhub_auth_token');
                                window.sessionStorage.removeItem('_currentPlace');
                                window.sessionStorage.removeItem('_circles');
                                window.sessionStorage.removeItem('_currentPlace2020');
                                window.sessionStorage.removeItem('_currentPlace2020Pin');
                                window.sessionStorage.removeItem('_location');
                                window.sessionStorage.removeItem('_radius');
                                window.sessionStorage.removeItem('_radius_text');
                                window.sessionStorage.removeItem('_radius_text_location');
                                window.sessionStorage.removeItem('_radius_text_radius');
                                window.sessionStorage.removeItem('_radius_units');
                                window.sessionStorage.removeItem('_radius_units_location');
                                window.sessionStorage.removeItem('_radius_units_radius');

                                parent.postMessage('StoreDMOrder:' + orderId, '*');

                                this.loading = false;

                                if (dataType == '1') {
                                    window.sessionStorage.setItem('_fulfilment_type', 'leadhub');
                                    this.navigate('select-data-leadhub')
                                }

                                if (dataType == '2') {
                                    window.sessionStorage.setItem('_fulfilment_type', 'databook');
                                    this.navigate('select-data-databook')
                                }

                                if (dataType == '3') {
                                    //TODO
                                }
                            })
                            .catch(error => {
                                if (error.response) {
                                    //    this.$message.error('Sorry there has been an issue retrieving the information you requested.');
                                    console.log('data order patch failure: ' + JSON.stringify(error.response));
                                }

                                this.loading = false;
                            });
                    })
                    .catch(error => {
                        console.log(error)

                        this.loading = false;
                    });
            },
            goBack() {
                window.sessionStorage.removeItem('_fulfilment_type');
                //window.sessionStorage.setItem('_showProfile', true);
                this.navigate('profile');
                //this.navigate('');
            },
        }
    };
</script>
